import { mergeObjectTypes } from '../cacheHelpers';

const MetricValueWithSI = {
  merge: mergeObjectTypes
};

export default MetricValueWithSI;
